// Shared formatters for the management UI.

/** Unix seconds → localized date+time. */
export function fmtDateTime(tsSec: number): string {
  return new Date(tsSec * 1000).toLocaleString();
}

/** Unix seconds → localized date. */
export function fmtDate(tsSec: number): string {
  return new Date(tsSec * 1000).toLocaleDateString(undefined, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}

/** Byte count → human-readable (KiB/MiB/GiB, binary). */
export function fmtBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  const units = ["KiB", "MiB", "GiB", "TiB"];
  let v = n / 1024;
  let i = 0;
  while (v >= 1024 && i < units.length - 1) {
    v /= 1024;
    i++;
  }
  return `${v.toFixed(v < 10 ? 1 : 0)} ${units[i]}`;
}
